<template>
  <div class="row">
    <div class="col-md-12">
      <location-form :route="route"></location-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import LocationForm from 'src/components/Dashboard/Views/Settings/Locations/LocationForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      LocationForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        tableManagementModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      // onUserSubmit (model, isValid) {
      //   this.tableManagementModel = model
      // }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/LocationEdit.vue